/* eslint-disable @typescript-eslint/no-explicit-any */
import { Chip, Typography } from '@material-ui/core'
import _ from 'lodash'
import React from 'react'
import {
  KeywordDto,
  MaterialSummaryDto,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { useKeywordsTranslation } from './useKeywordsTranslation'

type MaterialTagsProps = {
  selectedTokens: MaterialSummaryDto['tokens']
  size?: 'small' | 'medium'
  variant?: 'default' | 'text-caption'
  showCategories?: KeywordDto['category'][]
}

const MaterialTags = (props: MaterialTagsProps) => {
  const { asArrayOfTranslatedKeywords } = useKeywordsTranslation()

  let keywordsWithTranslation = asArrayOfTranslatedKeywords(
    props.selectedTokens,
    { disableSorting: true }
  )

  if (props.showCategories?.length) {
    keywordsWithTranslation = keywordsWithTranslation.filter((x) =>
      props.showCategories.includes(x.category)
    )
  }

  if (props.variant === 'text-caption') {
    return (
      <div
        style={{
          width: '100%',
          display: 'flex',
          textAlign: 'left',
          gridGap: 4,
          justifyContent: 'flex-start',
        }}
      >
        <Typography
          variant={'caption'}
          style={{ cursor: 'inherit' }}
          color="textSecondary"
          // noWrap
        >
          {keywordsWithTranslation.map((x, i) => {
            return (
              <span
                key={x.originalKeyword}
                style={{ cursor: 'inherit' }}
                color="textSecondary"
              >
                {x.translatedString +
                  (i < keywordsWithTranslation.length - 1 ? ' | ' : '')}
              </span>
            )
          })}
        </Typography>
      </div>
    ) as any
  }

  return (
    <div
      style={{
        width: '100%',
        flexWrap: 'wrap',
        display: 'flex',
        textAlign: 'left',
        gridGap: 4,
      }}
    >
      {keywordsWithTranslation.map((x) => (
        <Chip
          key={x.originalKeyword}
          label={x.translatedString}
          size={props.size || 'small'}
          style={{ cursor: 'inherit' }}
          variant="outlined"
        />
      ))}
    </div>
  ) as any
}

export default React.memo(MaterialTags, _.isEqual)
